export default "__VITE_ASSET__DB8blGV8__"